export default __webpack_public_path__ + "static/media/goopter-ecommerce-dining-automation-process.df8236ae.png";